/* @flow */
import idx from 'idx';
import invariant from 'invariant';
import errorLogger from 'utils/errorLogger';
import GroupActions from 'groups/actions/GroupActions';
import Groups from 'collections/Groups';
import GroupStore from 'groups/stores/GroupStore';
import OrganizationActions from 'actions/OrganizationActions';
import SettingsActions from 'actions/SettingsActions';
import SettingsStore from 'stores/SettingsStore';
import User from 'entities/User';
import { logIfUnexpected401 } from 'lib/WindowUser';

const graphQlErrorIsUnauthenticated = e =>
  idx(e, _ => _.serviceMetadata.service_response.code) === 'unauthenticated';

export const errorIsUnauthenticated = (error: Object): boolean =>
  !!(
    error &&
    (error.code === 'unauthenticated' ||
      (error.graphQLErrors && error.graphQLErrors.some(graphQlErrorIsUnauthenticated)))
  );

function promiseGroups(): Promise<?Groups> {
  if (GroupStore.isLoaded()) {
    return Promise.resolve();
  } else {
    return GroupActions.loadGroups(undefined, false)
      .then(undefined, error => {
        if (errorIsUnauthenticated(error)) {
          console.warn(error, error.stack);
          console.warn('promiseGroups unauthenticated');
          logIfUnexpected401();
        } else {
          console.warn(error, error.stack);
          console.error('promiseGroups failure');
        }
      })
      .catch(errorLogger('promiseGroups runtime error'));
  }
}

export function promiseSettings(): Promise<void> {
  if (SettingsStore.isLoaded()) {
    return Promise.resolve();
  } else {
    // then to return void
    return SettingsActions.loadSettings().then(() => {});
  }
}

export function promiseAppData(user: User): Promise<void> {
  invariant(user, 'promiseAppData only works if user is authenticated');
  promiseGroups();
  OrganizationActions.loadUserOrganizations(false)
    .then(undefined, error => {
      if (errorIsUnauthenticated(error)) {
        console.warn(error, error.stack);
        console.warn('loadUserOrganizations unauthenticated');
        logIfUnexpected401();
      } else {
        console.warn(error, error.stack);
        console.error('loadUserOrganizations failure');
      }
    })
    .catch(errorLogger('loadUserOrganizations runtime error'));
  return promiseSettings().then(() => {});
}
